
import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProjectAccessEmployeeRelations = (
    backend: string,
    token: string,
    projectId: number,
) => {
    return fetch(
        `${getApiUrl(backend)}project_access_employee_relations/${projectId}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getProjectAccessEmployeeRelations;